/* ============
 * Getters for the Reminder module
 * ============
 *
 * The getters that are available on the
 * Reminder progress module.
 */
import {
  clone
} from '@/utils/object';

const getReminders = state => clone(state.assessmentReminders);
const isReminderListLoading = state => state.isReminderListLoading;
const getTotalCount = state => clone(state.totalCount);

export default {
  getReminders,
  isReminderListLoading,
  getTotalCount
};
